export default class FaixaHoraExtra {
    constructor() {
        this.id = null;
        // 1 normal, 2 noturna
        this.tipo = null;       
        this.ate = null;       
        this.segundaSexta = null;              
        this.sabado = null;
        this.domingo = null;
        this.feriado = null;
        this.folga = null;    
    }    
}